import { Badge } from '@aimsos/ui';
import SectionCard from './SectionCard.jsx';

/**
 * The About block, split into the prototype's separate cards: the summary, the
 * connector's capabilities, the use-case list, and — once connected — the OAuth
 * scopes it requests (not-connected surfaces those in "Before you connect").
 */
function AboutSections({ t, provider, showScopes = false }) {
  return (
    <>
      <SectionCard title={t('integrations.provider.overview.about')}>
        <p className="text-sm text-content-muted">{provider.about}</p>
      </SectionCard>

      {provider.capabilities.length > 0 && (
        <SectionCard
          title={t('integrations.provider.overview.whatYouCanDo')}
          meta={t('integrations.provider.overview.capabilitiesDeclared', {
            count: provider.capabilities.length,
          })}
        >
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            {provider.capabilities.map((cap) => (
              <div key={cap.id} className="rounded-lg border border-edge bg-surface-muted/40 p-3">
                <Badge variant="neutral" size="small" radius="full">
                  {t(`integrations.provider.overview.capabilityTypes.${cap.type}`)}
                </Badge>
                <p className="mt-2 text-xs text-content-muted">{cap.description}</p>
              </div>
            ))}
          </div>
        </SectionCard>
      )}

      {provider.useCases.length > 0 && (
        <SectionCard title={t('integrations.provider.overview.useCases')}>
          <ul className="flex flex-col gap-1.5 text-sm text-content-muted">
            {provider.useCases.map((uc) => (
              <li key={uc} className="flex gap-2">
                <span
                  aria-hidden="true"
                  className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-content-faint"
                />
                <span>{uc}</span>
              </li>
            ))}
          </ul>
        </SectionCard>
      )}

      {showScopes && provider.scopes.length > 0 && (
        <SectionCard
          title={t('integrations.provider.overview.requiredScopes')}
          meta={t('integrations.provider.overview.scopesRequested', {
            count: provider.scopes.length,
          })}
        >
          <div className="flex flex-wrap gap-1.5">
            {provider.scopes.map((scope) => (
              <Badge key={scope} variant="neutral" size="small" radius="default">
                {scope}
              </Badge>
            ))}
          </div>
        </SectionCard>
      )}
    </>
  );
}

export default AboutSections;
